/**
 * Decodes HTML entities to their corresponding Unicode characters
 * @param text - The text containing HTML entities
 * @returns The text with HTML entities decoded
 */
export function decodeHtmlEntities(text: string): string {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
  }
  
  /**
   * Alternative method for decoding HTML entities that doesn't rely on DOM
   * @param text - The text containing HTML entities
   * @returns The text with HTML entities decoded
   */
  export function decodeHtmlEntitiesFallback(text: string): string {
    return text
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&#x([0-9a-fA-F]+);/g, (_match, hex) => {
        return String.fromCodePoint(parseInt(hex, 16));
      })
      .replace(/&#(\d+);/g, (_match, dec) => {
        return String.fromCodePoint(parseInt(dec, 10));
      });
  }
  
  /**
   * Safely decodes HTML entities using the best available method
   * @param text - The text containing HTML entities
   * @returns The text with HTML entities decoded
   */
  export function safeDecodeHtmlEntities(text: string): string {
    try {
      // Try using DOM method first (more comprehensive)
      if (typeof document !== 'undefined') {
        return decodeHtmlEntities(text);
      }
    } catch (error) {
      console.warn('DOM-based HTML entity decoding failed, using fallback method:', error);
    }
    
    // Fallback to manual decoding
    return decodeHtmlEntitiesFallback(text);
  }
